import { useStore } from 'reactflow';

// returns current react flow zoom level
export const useZoom = () => {
    return useStore(s => s.transform[2]);
};
